export default __webpack_public_path__ + "static/media/45.b6bbd2c9.svg";